export default __webpack_public_path__ + "static/FS2S-InHub-181-cdc560c0d897507966c04e2ac18385af.jpg";